import WallOfLove from '$lib/storyblok/blocks/homepage/wallOfLove.svelte';
import WinnerCard from '$lib/storyblok/blocks/wallOfLove/winnerCard.svelte';
import PodcastCard from '$lib/storyblok/blocks/wallOfLove/podcastCard.svelte';
import VideoCard from '$lib/storyblok/blocks/wallOfLove/videoCard.svelte';
import YotpoReviewCard from '$lib/storyblok/blocks/wallOfLove/yotpoReviewCard.svelte';
import YotpoSummaryCard from '$lib/storyblok/blocks/wallOfLove/yotpoSummaryCard.svelte';
import QuoteCard from '$lib/storyblok/blocks/wallOfLove/quoteCard.svelte';
import MediaOutletCard from '$lib/storyblok/blocks/wallOfLove/mediaOutletCard.svelte';
import AwardCard from '$lib/storyblok/blocks/wallOfLove/awardCard.svelte';
import FeaturedArticle from '$lib/storyblok/blocks/wallOfLove/featuredArticle.svelte';
import FeaturedInContainer from '$lib/storyblok/blocks/nycLp/homepageModules/featuredInContainer.svelte';
import ChefCard from './blocks/wallOfLove/chefCard.svelte';
import InstagramVideoCard from './blocks/wallOfLove/instagramVideoCard.svelte';
import WallOfLoveExtended from './blocks/wallOfLoveExtended.svelte';

export default {
	wall_of_love: WallOfLove,
	wall_of_love_extended: WallOfLoveExtended,
	homepage_winner_card: WinnerCard,
	podcast_card: PodcastCard,
	homepage_video_card: VideoCard,
	yotpo_review_card: YotpoReviewCard,
	yotpo_summary_card: YotpoSummaryCard,
	quote_card: QuoteCard,
	media_outlet_card: MediaOutletCard,
	award_card: AwardCard,
	featured_article: FeaturedArticle,
	featured_in_container: FeaturedInContainer,
	chef_card: ChefCard,
	instagram_video_card: InstagramVideoCard
};
